/**
 * store/endpoint/index.js
 *
 * Actions for the store's endpoint object.
 *
 */


/**
 * sets the user object to the payload
 *
 * @param state
 * @param payload
 * @returns {{endpoint: *}}
 */
export const set = (state, { payload }) => ({
    ...state,
    endpoint: payload,
});

/**
 * clears the user object.
 *
 * @param state
 * @returns {{endpoint: {}}}
 */
export const clear = (state) => ({
    ...state,
    endpoint: {},
})
